import HeaderBottomOne from "../common/header/HeaderBottomOne";
import FooterOne from "../common/footer/FooterOne";

const PDFViewer = () => {
  return (
    <>
      <HeaderBottomOne />
      <div style={{ padding: "10px" }} className="pdfviewer">
        {/* Download Button */}
        <div style={{ marginBottom: "15px", textAlign: "center" }}>
          <a
            href="/files/Circular Economy Action Plan.pdf"
            download
            style={{
              padding: "10px 20px",
              backgroundColor: "#4c9152",
              color: "white",
              borderRadius: "5px",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            View CE Action Plan
          </a>
        </div>

        {/* Embedded PDF Viewer */}
        <iframe
          src="/files/Circular Economy Action Plan.pdf"
          title="CE Action Plan"
          width="100%"
          height="1200px"
          style={{
            border: "none",
            minHeight: "500px",
            display: "block",
          }}
        />
      </div>
      <FooterOne />
    </>
  );
};

export default PDFViewer;
